import React from 'react';
import reducer from 'reducers';
import { connectRouter, routerMiddleware } from 'connected-react-router'
import { createStore, applyMiddleware, compose } from 'redux';
import DevTools from 'config/devtools';
import promiseMiddleware from 'config/promiseMiddleware';
import createSagaMiddleware from 'redux-saga';
import rootSaga from '../sagas';

const sagaMiddleware = createSagaMiddleware();
const productionMiddlewares = [promiseMiddleware,sagaMiddleware];
// const productionMiddlewares = [sagaMiddleware];

const middlewares = process.env.NODE_ENV === 'development' ?
  [applyMiddleware(sagaMiddleware),applyMiddleware(promiseMiddleware), DevTools.instrument()] :
  [applyMiddleware(sagaMiddleware),applyMiddleware(promiseMiddleware)];

const initialize = (initialState = {}) => {
  const history = initialState.history;
  const store = createStore(
    connectRouter(history)(reducer),
    // initialState,
    compose(...middlewares, applyMiddleware(routerMiddleware(history))));

  sagaMiddleware.run(rootSaga);

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers', () => {
      const nextReducer = require('../reducers');
      // store.replaceReducer(nextReducer);
      store.replaceReducer(connectRouter(history)(nextReducer));
    });
  }
  return store;
};

export default initialize;

